import { queryOptions } from '@tanstack/react-query'

import { fetchCustomer } from '../api/fetch-customer'
import { customersQueryKeys } from '../query-keys'

export const getCustomerQueryOptions = (param: {
  tenantKey: string
  customerId: number
}) =>
  queryOptions({
    queryKey: customersQueryKeys.detail(param.tenantKey, param.customerId),
    queryFn: async ({ signal }) => fetchCustomer(param, signal)
  })
